export default class ProductLinkService {
  constructor() {
    this.linkIsFromProductPage = false;
  }

  getProductLinkVerification() {
    return this.linkIsFromProductPage;
  }

  setProductLinkVerification(bool) {
    this.linkIsFromProductPage = bool;
  }

  setSearchParams(params) {
    this.searchedSolutions = params.solutions;
  }

  getSearchParams() {
    return this.searchedSolutions;
  }
}



// WEBPACK FOOTER //
// ./src/services/productLink.service.js